import { HipaaDisclaimer } from "./HipaaDisclaimer";

export class HipaaForm {

   //public formContent: string;
   public  formName: string  
   static formContent: any;
   static hipaaDisclaimers: HipaaDisclaimer[];
   constructor() {
       // this.formContent = '';
        this.formName = '';
       // this.hipaaDisclaimers = [];
   }

}
